import { TFunction } from 'next-i18next';
import { getField } from 'components/blocks/BasicDetailsInnerBlock';
import {
    FieldIconInterface,
    FieldInterface,
    FieldSize,
} from 'components/interfaces/GeneralInterface';
import { TagApiInterface } from 'submodules/api_middleware';
import AlertCircle from 'components/icon/icons/alert_circle.svg';
import styles from './IndiciesField.module.scss';

const getValue = (value: string) => {
    switch (value) {
        case 'inactive':
            return false;
        case 'archived':
            return false;
        case 'in_progress':
            return true;
        case 'warning':
            return {
                icon: AlertCircle,
                className: styles.warningIcon,
            } as FieldIconInterface;
        default:
            return true;
    }
};

const getClassValue = (value: string): string => {
    switch (value) {
        case 'inactive':
            return styles.iconRed;
        case 'archived':
            return styles.iconGray;
        case 'in_progress':
        case 'warning':
            return styles.iconOrange;
        default:
            return styles.iconGreen;
    }
};

export const getIndiciesFields = (
    t: TFunction,
    indicies: TagApiInterface[] = []
): FieldInterface[] =>
    indicies.map((ind) =>
        getField(
            t,
            getValue(ind.value),
            ind.label,
            FieldSize.UNSET,
            undefined,
            undefined,
            getClassValue(ind.value),
            undefined,
            undefined,
            ind['link'],
            true,
            undefined,
            undefined,
            undefined,
            ind.title
        )
    );
